import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";

export const PRESENT_STATUS = {value: "", label: "Present"};
export const ABSENT_STATUS = {value: "absent", label: "Absent"};


export const getAbsenceStatus = (status) =>
{
    return status === "" ? PRESENT_STATUS : ABSENT_STATUS; //Empty value in present to match database
}

const DropdownAbsenceStatus = ({absence_code, control, fieldName}) =>
{
    const options = [
        PRESENT_STATUS,
        ABSENT_STATUS,
    ]

    return <div>
        <CommonDropdown items={options} control={control} readOnly={false} placeholder={"Absence status"} name={fieldName}/>
    </div>
}

export default DropdownAbsenceStatus;